import ProjectImage from './ProjectImage.react';
import ProjectLogo from './ProjectLogo.react';
import ProjectText from './ProjectText.react';
import ProjectHeader from './ProjectHeader.react';
import ProjectVideo from './ProjectVideo.react';
import ProjectSlider from './ProjectSlider.react';

import Config from '../../utils/Config';

class Project extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false,
            project : false
        };

        this.onHeaderClick = this.onHeaderClick.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.nextProject = this.nextProject.bind(this);
    }

    componentDidMount() {


        // $('#pre-loader').animate({ opacity : 1 }, 200);

        // setTimeout(() => {
        //     $('#pre-loader').css({ display : 'none' });
        // });

        $('a').click(this.onHeaderClick);
    }

    onHeaderClick(e) {
        if (!this.state.visible)
            return;

        var h = e.target.hash;
        if (h === '#hero' || h === '#portfolio' || h === '#services' || h === '#about' || h === '#team' || h === '#contact')
            this.hide();
    }

    show(id) {
        var self = this;
        var projects = this.props.projects;

        $('#pre-loader').css({ display : 'inline', 'opacity' : 1 });
        $.ajax({
            url: './content/'+projects[id].id+'.txt',
            async: false,
            success:function(data) {

                self.setState({
                    visible : true,
                    project : JSON.parse(data)
                }, function() {
                    $('#app').css({ 'overflow-y' : 'hidden' });
                    location.hash = self.state.project.id;

                    // if ($('#app').scrollTop() > 0 && !$('#header').hasClass('header__opaque'))
                        $('#header').addClass('header__opaque');
                });
            }
        });

    }

    hide() {
        var self = this;

        $('#app').css({ 'overflow-y' : 'scroll' });
        $('.project').css({ opacity : 0 });

        setTimeout(function() {
            self.setState({
                visible : false,
                project : false
            }, () => {
                if ($('#app').scrollTop() === 0)
                    $('#header').removeClass('header__opaque');
            });
        }, 600);
    }

    nextProject() {
        var self = this;

        var id = this.state.project.id;
        var next_id = false;

        var projects = this.props.projects;

        for (var i=0; i<projects.length; i++) {
            if (projects[i].id === id) {
                next_id = i === projects.length - 1 ? 0 : i+1;
            }
        }
        $('#pre-loader').css({ display : 'inline', 'opacity' : 1 });

        this.show(next_id);
    }

    render() {

        if (!this.state.visible)
            return null;

        var project = this.state.project;

        return (
            <div
                className='project'
                onScroll={this.onScroll}
                style={{ 'backgroundImage' : 'url(/public/codi-studios/projects/'+project.id+'/background.jpg)' }}>

                <div
                    className='project__close'
                    onClick={this.hide} />

                <ProjectHeader
                    project={project}
                    key={project.id} />

                { project.content.map(function(data, i) {

                    if (data.type === 'logo') {
                        return (
                            <ProjectLogo
                                id={project.id}
                                project={data}
                                key={'project_logo_'+project.id+i} />
                        );
                    }

                    if (data.type === 'text') {
                        return (
                            <ProjectText
                                id={project.id}
                                project={data}
                                key={'project_text_'+project.id+i} />
                        );
                    }

                    if (data.type === 'image') {
                        return (
                            <ProjectImage
                                id={project.id}
                                project={data}
                                key={'project_image_'+data.img+i} />
                        );
                    }

                    if (data.type === 'video') {
                        return (
                            <ProjectVideo
                                id={project.id}
                                project={data}
                                key={'project_video_'+project.id+i} />
                        );
                    }

                    if (data.type === 'slider') {
                        return (
                            <ProjectSlider
                                id={project.id}
                                project={data}
                                key={'project_slider_'+project.id+i} />
                        );
                    }
                })}

                <div
                    className='project__next smoothscroll'
                    onClick={this.nextProject}>

                    NEXT PROJECT
                </div>
            </div>
        );
    }
}

export default Project;



// WEBPACK FOOTER //
// ./ui_src/app/components/portfolio/Project.react.jsx